import { Diamond } from "@phosphor-icons/react";
import { useLanguage } from "@/i18n";

export default function Marquee() {
  const { t } = useLanguage();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-gold/10 bg-[#0D0D0D] py-6">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-xl uppercase tracking-[0.3em] text-gold/70 md:text-2xl">
                  {item}
                </span>
                <Diamond size={10} weight="fill" className="text-gold/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
